<div [class.center]="fullPanel">
  <div class="lds-spinner" [class.half-size]="!fullPanel">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
